import { urlFor } from '@/lib/sanity';

import defaultOG from '../../public/img/opengraph.png';

export default function getImage(image, { width = 800, height = 600, quality = 100 } = {}) {
  if (!image?.asset) {
    return {
      src: defaultOG.src,
      width: defaultOG.width || 1200,
      height: defaultOG.height || 630,
      blurDataURL: `${defaultOG.src}`,
    };
  }

  const url = urlFor(image).width(width).quality(quality).auto('format').url();

  const blurUrl = urlFor(image).width(20).blur(10).quality(10).url();

  return {
    src: url,
    width,
    height,
    blurDataURL: blurUrl,
  };
}
